// import { useAuthenticator } from '@aws-amplify/ui-react-native'; // native
import { useAuthenticator } from '@aws-amplify/ui-react'; // web
import { Hub } from 'aws-amplify/utils';
import { useEffect } from 'react';

/**
 * Subscribe to Cognito authentication events.
 */
export const CognitoAuthEventListener = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  // Log Cognito status changes
  useEffect(() => {
    console.log(`[auth:cognito]: ${authStatus}`);
  }, [authStatus]);

  // Listen and log Cognito events
  useEffect(() => {
    const unsubscribe = Hub.listen('auth', async ({ payload }) => {
      const { event } = payload;
      console.log(`[auth:cognito] Event: ${event}`);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  return null;
};
